export default __webpack_public_path__ + "static/media/InvalidScan.f99f8ab7.mp3";